import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-141">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-charcoal/60 backdrop-blur-sm z-40" data-id="element-142" />
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none" data-id="element-143">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-xl pointer-events-auto flex flex-col overflow-hidden" data-id="element-144">
              <div className="flex items-center justify-between p-6 border-b border-cream-200" data-id="element-145">
                <h2 className="text-2xl font-serif font-semibold text-charcoal" data-id="element-146">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-charcoal-light hover:text-charcoal hover:bg-cream-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-147">
                  <XIcon size={24} data-id="element-148" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto text-charcoal-light leading-relaxed" data-id="element-149">
                {children}
              </div>
              <div className="p-6 border-t border-cream-200 bg-cream-50 flex justify-end" data-id="element-150">
                <button onClick={onClose} className="px-6 py-2 bg-charcoal text-white rounded-lg font-medium hover:bg-charcoal-light transition-colors" data-id="element-151">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}